module.exports = __webpack_public_path__ + "img/pending.b18549f.png";